<script>
/**
 * Pick files out of the file store to put on a record (an email's
 * attachments): every folder the user may see, its files as checkboxes,
 * then Attach. Emits `pick` with the chosen file ids.
 */
export default {
  name: 'file-store-picker',

  data() {
    return {
      folders: [],
      loading: true,
      picked: [],
    }
  },

  async mounted() {
    try {
      const r = await this.asyncAction('/api/filestore', 'GET', {params: {files: 1}, noload: true})
      this.folders = [...r.system, ...r.personal].filter(f => (f.files || []).length)
    } finally {
      this.loading = false
    }
  },

  methods: {
    size(bytes) {
      if (bytes >= 1048576)
        return (bytes / 1048576).toFixed(1) + ' MB'
      return Math.max(1, Math.round(bytes / 1024)) + ' KB'
    },
    attach() {
      if (this.picked.length)
        this.$emit('pick', [...this.picked])
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!loading && !folders.length" class="text-muted font-italic py-3 text-center">
      Nothing in the file store yet - add files to a folder from the user menu's File Store.
    </div>
    <b-form-checkbox-group v-else v-model="picked" stacked>
      <b-list-group v-for="f in folders" :key="f.id" class="mb-2">
        <b-list-group-item variant="info" class="py-1">
          <font-awesome-icon :icon="['fas', 'folder']" fixed-width class="mr-1"/>{{ f.name }}
          <small class="text-muted ml-1">{{ f.system ? 'system' : 'personal' }}</small>
        </b-list-group-item>
        <b-list-group-item v-for="file in f.files" :key="file.id" class="py-1">
          <b-form-checkbox :value="file.id">{{ file.orig_filename }}<small v-if="file.file_size" class="text-muted ml-2">{{ size(file.file_size) }}</small></b-form-checkbox>
        </b-list-group-item>
      </b-list-group>
    </b-form-checkbox-group>
    <div v-if="folders.length" class="text-right">
      <b-button variant="outline-primary" size="sm" :disabled="!picked.length" @click="attach">
        Attach {{ picked.length || '' }}
      </b-button>
    </div>
  </div>
</template>
